module.exports = __webpack_public_path__ + "img/TailWing_II-Profiles.a0d607d5.jpg";